<template>
    <div class="mg-conf-agenda">
        <button @click="toggleCollapseAll()" class="no-print" style="margin-bottom: 35px;padding: 15px; float: right;">{{ agenda.collapseAll ? "EXPAND" : "COLLAPSE" }} ALL</button>
        <ConfAgendaDates />
        <div class="flex items-start flex-col md:flex-row">
            <ConfAgendaFilters />
            <ConfAgendaSessions />
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";

import ConfAgendaDates from "./ConfAgendaDates.vue";
import ConfAgendaSessions from "./ConfAgendaSessions.vue";
import ConfAgendaFilters from "./ConfAgendaFilter.vue";

export default {
    props: {
        initialData: { type: Array }
    },
    components: {
        ConfAgendaDates,
        ConfAgendaSessions,
        ConfAgendaFilters
    },
    data() {
        return {};
    },
    beforeMount() {
        this.setInitialData(this.initialData);
        this.resetFilters();
    },
    computed: {
        ...mapState(["agenda"]),
    },
    methods: {
        ...mapMutations(["setInitialData","toggleCollapseAll"]),
        ...mapActions(["resetFilters"])
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/conference-agenda/ConfAgendaMain.vue